/* context var for sharing transition state with deeper child components
https://reactjs.org/docs/context.html */

import React from 'react';

const IsPageTransitioning = React.createContext(false);
export default IsPageTransitioning;
